import axios from 'axios';

import { isProd } from '../utils/env';
import type { Lucid } from '../types';

const splunk = async (data: Lucid.Splunk.Data) => {
  const { product, errorMessage, location, severity = 'Unknown', datadogErrorTag = 'marketing.unknown' } = data;

  if (!product || !errorMessage || !location) {
    throw new Error('Error: product, errorMessage, & location are required.');
  }

  const analyticsURL = `https://analytics.lucid${isProd() ? '' : 'preprod'}.app/marketingErrors`;
  const currentTimestamp = new Date().toString();

  const errorData: Lucid.Splunk.Errors = {
    build: {
      name: `corporate-${product}`,
      timestamp: currentTimestamp,
      version: 'gatsby',
    },
    errors: [
      {
        message: errorMessage,
        location: location,
        datadogErrorTag,
        severity,
      },
    ],
  };

  try {
    const response = await axios({
      method: 'POST',
      url: analyticsURL,
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(errorData),
    });

    if (response.status >= 200 && response.statusText === 'Accepted') {
      console.info('Logged error message');
    }
  } catch (error) {
    console.error(error);
  }
};

export default splunk;
